import {request} from "../../Base/HTTP";
import HttpMethod from "../../Constants/Base/HttpMethod";

export async function getCompanyDocumentTemplateSteps(data) {
    return await request('/api/company-document-template-step', data);
}

export async function addCompanyDocumentTemplateStep(data) {
    return await request('/api/company-document-template-step', data, HttpMethod.POST);
}